<template>
  <v-page page="scoresQuartiles">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex>
          <v-flex>
            <v-card class="elevation-4">
              <v-card-title>
                <h4>Upload Quartiles & Aligns</h4>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-alert :value="true" color="info">
                  <h5>{{filenameText}}</h5> <em>{{ file.filename }}</em>
                </v-alert>
              </v-card-text>
              <v-flex>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <input class="d-none" type="file" :ref="inputRef" @change="parse($event.target.files)"/>
                      <v-btn
                        :color="browseButtonColor"
                        :ref="buttonRef"
                        @click.native="file['filename'] !== null ? validateAndUpload() : $refs[inputRef].click()">
                        <v-icon left>
                          {{ saveButtonIcon }}
                        </v-icon>
                          {{ saveButtonText }}
                      </v-btn>
                </v-card-actions>
              </v-flex>
              <v-flex>
                <v-tabs class="elevation-4" v-model="activeTab">
                  <v-tab :key="tabs[0].name">
                    Active Quartiles
                  </v-tab>
                  <v-tab-item>
                    <v-card>
                      <v-data-table
                        :headers="quartile_headers"
                        :items="quartile_items"
                        class="elevation-1"
                        :options.sync=pagination
                        :loading=loading
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                      >
                        <template v-slot:item="props">
                          <tr>
                            <td class="text-xs-left">{{ props.item.id }}</td>
                            <td class="text-xs-left">{{ props.item.organization_id }}</td>
                            <td class="text-xs-left">{{ props.item.internal }}</td>
                            <td class="text-xs-left">{{ props.item.model_name }}</td>
                            <td class="text-xs-center">{{ props.item.location_name }}</td>
                            <td class="text-xs-center">{{ props.item.lower_boundary > 0 ? props.item.lower_boundary.toFixed(3) : 0 }}</td>
                            <td class="text-xs-center">{{ props.item.upper_boundary.toFixed(3) }}</td>
                            <td class="text-xs-center">{{ props.item.quartile_label_id }}</td>
                            <td class="text-xs-center">{{ props.item.model_version }}</td>
                            <td class="text-xs-center">{{ props.item.import_version }}</td>
                            <td class="text-xs-left">{{ new Date(props.item.created_at).toLocaleString() }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-tab-item>
                  <v-tab :key="tabs[1].name">
                    Active Quartile Aligns
                  </v-tab>
                  <v-tab-item>
                    <v-card>
                      <v-data-table :headers="aligns_headers" :items="align_items" class="elevation-1" :loading=loading>
                        <template v-slot:item="props">
                          <tr>
                            <td>{{ props.item.id }}</td>
                            <td>{{ props.item.organization_id }}</td>
                            <td>{{ props.item.location_name }}</td>
                            <td>{{ props.item.custom_location_name }}</td>
                            <td>{{ props.item.version }}</td>
                            <td>{{ new Date(props.item.created_at).toLocaleString() }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-flex>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </v-page>
</template>
<script>
import VPage from '@/layouts/Default'
import { Bus } from '@/bus'
import { apiErrorHandler } from '@/core/helpers/api.helpers'

export default {
  name: 'scoresQuartiles',
  components: {
    VPage
  },
  data () {
    return {
      quartile_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Organization Id', value: 'organization_id' },
        { text: 'Internal', value: 'internal' },
        { text: 'Model Name', value: 'model_name' },
        { text: 'Location Name', value: 'location_name' },
        { text: 'Lower Bound', value: 'lower_boundary' },
        { text: 'Upper Bound', value: 'upper_boundary' },
        { text: 'Quartile #', value: 'quartile_label_id', align: 'center' },
        { text: 'Model #', value: 'model_version', align: 'center' },
        { text: 'Import #', value: 'import_version' },
        { text: 'Created Date', value: 'created_at' }
      ],
      aligns_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Organization Id', value: 'organization_id' },
        { text: 'Location Name', value: 'location_name' },
        { text: 'Custom Location Name', value: 'custom_location_name' },
        { text: 'Version', value: 'version' },
        { text: 'Created Date', value: 'created_at' }
      ],
      file: {
        'filename': null,
        'data': null
      },
      quartile_items: [],
      align_items: [],
      pagination: {
        rowsPerPage: 5
      },
      activeTab: 0,
      quartileTabName: 'Quartile',
      alignsTabName: 'QuartileAlign',
      tabs: [
        { id: 0, name: 'Quartile' },
        { id: 1, name: 'QuartileAlign' }
      ],
      loading: false,
      sortBy: 'id',
      sortDesc: true
    }
  },
  props: {
    browseButtonText: {
      type: String,
      default: 'Browse File'
    },
    browseButtonIcon: {
      default: 'search'
    },
    browseButtonColor: {
      default: 'primary'
    },
    uploadButtonText: {
      type: String,
      default: 'Upload File'
    },
    uploadButtonIcon: {
      default: 'cloud_upload'
    },
    uploadButtonColor: {
      default: 'primary'
    }
  },
  computed: {
    filenameText () {
      if (this.activeTab === 0) {
        return 'You will submit the following Quartiles: '
      } else {
        return 'You will submit the following Quartile Aligns: '
      }
    },
    inputRef () {
      return `file-input-${this._uid}`
    },
    buttonRef () {
      return `file-button-${this._uid}`
    },
    saveButtonText () {
      if (this.file['filename']) {
        return this.uploadButtonText
      } else {
        return this.browseButtonText
      }
    },
    saveButtonIcon () {
      if (this.file['filename']) {
        return this.uploadButtonIcon
      } else {
        return this.browseButtonIcon
      }
    }
  },
  methods: {
    async parse (files) {
      if (Array.from(files).length !== 1) {
        let error = new Error('Accept only one file per upload!')
        error.name = 'Multiple Files'
        console.error(error)
        this.$set(this, 'errors', [{
          name: 'General',
          errors: [ error ]
        }])
        return
      }

      let file = files[0]

      if (file.type !== 'text/csv') {
        let error = new Error('Not a csv!')
        error.name = 'Invalid File Type'
        console.error(error)
        this.$set(this, 'errors', [{
          name: 'Invalid File Type',
          errors: [ error ]
        }])
        return
      }

      if (file) {
        let reader = new FileReader()

        reader.onload = e => {
          this.file = {}
          this.file.filename = file.name
          this.file.data = e.target.result
        }
        reader.readAsArrayBuffer(file)
      }
    },
    getActiveQuartiles () {
      this.loading = true
      this.$store.dispatch('scores/retrieveQuartiles')
        .then(response => {
          this.quartile_items = response['quartiles']
          this.align_items = response['quartile_aligns']
        })
        .catch((error) => {
          const message = apiErrorHandler(error)
          Promise.reject(message)
          Bus.$emit('alert', { color: 'error', message: 'Failed to retrieve active quartiles and aligns: ' + error })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async validateAndUpload () {
      if (this.tabs[this.activeTab].name === this.quartileTabName) {
        await this.$store.dispatch('scores/uploadQuartiles', { file: this.file }).then(() => {
          Bus.$emit('alert', { color: 'success', message: 'Succesfully uploaded quartiles' })
        }).catch(() => {
          Bus.$emit('alert', { color: 'error', message: 'Failed to upload quartile' })
        }).finally(() => {
          this.fileUploading = false
        })
      } else if (this.tabs[this.activeTab].name === this.alignsTabName) {
        await this.$store.dispatch('scores/uploadQuartileAligns', { file: this.file }).then(() => {
          Bus.$emit('alert', { color: 'success', message: 'Succesfully uploaded quartile aligns' })
        }).catch(() => {
          Bus.$emit('alert', { color: 'error', message: 'Failed to upload quartile aligns' })
        }).finally(() => {
          this.fileUploading = false
        })
      }
    }
  },
  mounted () {
    this.getActiveQuartiles()
  }
}
</script>

<style lang="sass">
.group-chip
  transition: background-color 0.5s ease
  &:hover
    background: #AAA !important

  .v-chip__content
    cursor: pointer
</style>
